export default "PDVEND";



// WEBPACK FOOTER //
// ./src/assets/enum/form-labels/pdvend/index.js